import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const CARD_IMGS = [
  "https://images.unsplash.com/photo-1719410876441-48357b53e6fd?crop=entropy&cs=srgb&fm=jpg&q=60&w=1200",
  "https://images.pexels.com/photos/1024967/pexels-photo-1024967.jpeg?auto=compress&cs=tinysrgb&dpr=1.2&h=650&w=940",
];

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.25 },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export default function SpecialMoments() {
  const { t } = useLang();
  const cards = t("moments.cards");

  return (
    <section id="momentos" data-testid="special-moments-section" className="py-24 sm:py-32 bg-[#FAF6EE]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <motion.div {...fadeUp} className="max-w-2xl mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#7A571C] mb-3">{t("moments.eyebrow")}</p>
          <h2 className="font-display font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B2E4A] text-balance">
            {t("moments.title")}
          </h2>
          <p className="mt-4 text-[#56636D] text-base sm:text-lg leading-relaxed">{t("moments.sub")}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
          {Array.isArray(cards) && cards.map((c, i) => (
            <motion.div key={c.to} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.1 }}>
              <Link to={c.to} data-testid={`moments-card-${i}`}
                className="group relative block rounded-3xl overflow-hidden min-h-[380px] sm:min-h-[440px] flex items-end">
                <img src={CARD_IMGS[i]} alt={c.title} loading="lazy" decoding="async"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B2E4A]/95 via-[#0B2E4A]/40 to-transparent" />
                <div className="relative z-10 p-8 sm:p-10">
                  <h3 className="font-display font-semibold text-2xl sm:text-3xl text-[#FAF6EE]">{c.title}</h3>
                  <p className="mt-3 text-sm sm:text-base text-[#F1E7D6]/80 leading-relaxed max-w-md">{c.text}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[#D9A854] font-semibold text-sm group-hover:gap-3.5 transition-all">
                    {c.cta} <ArrowRight size={16} />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
